import React, { Fragment, useEffect } from "react";
import { Field, useForm, useFormState } from "react-final-form";
import { OnChange } from "react-final-form-listeners";

// Web Final Form Components
import { FormGroup, Label, Col } from "reactstrap";
import { InputField, ReactSelect, ToggleField, required } from "modules/4_final_form/web";

// Mobile Final Form Components
import { InputField as MobileInputField, SmartSelect } from "modules/4_final_form/mobile";
import { connect } from "react-redux";
import { getAddressBookCompanies } from "modules/address_book/companies/actions";
import AddressBookCompanyAddButton from "modules/address_book/companies/web/add_button";

export const CompanyAttributes = ({ fieldName, namesUsed }) => {
  const form = useForm();

  const formState = useFormState();
  const thisField = _.get(formState?.values, fieldName);

  return (
    <Fragment>
      <FormGroup row>
        <Label md={3}>Label</Label>
        <Col md={8}>
          <Field name={`${fieldName}.label`} component={InputField} />
          <OnChange name={`${fieldName}.label`}>
            {(value, previous) => {
              if (value) {
                let name = _.snakeCase(value);
                // Check first character is a number
                if (name.match(/^\d/)) {
                  name = `_${name}`;
                }
                form.change(`${fieldName}.name`, name);
              }
            }}
          </OnChange>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Name</Label>
        <Col md={8}>
          <Field
            name={`${fieldName}.name`}
            component={InputField}
            validate={(value, values) => {
              if (!value) {
                return "is required";
              }
              if (namesUsed.includes(value)) {
                return "must be unique";
              }
            }}
            convertToLowerCase
            lettersOnly
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Placeholder</Label>
        <Col md={8}>
          <Field name={`${fieldName}.placeholder`} component={InputField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Required Field</Label>
        <Col md={8}>
          <Field name={`${fieldName}.required`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>On Dashboard</Label>
        <Col md={8}>
          <Field name={`${fieldName}.on_dashboard`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>On Report</Label>
        <Col md={8}>
          <Field name={`${fieldName}.on_report`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Ability to add new</Label>
        <Col md={3}>
          <Field name={`${fieldName}.add_new`} component={ToggleField} />
        </Col>
        {thisField?.add_new && (
          <Fragment>
            <Label md={3}>Disable existing projects</Label>
            <Col md={3}>
              <Field name={`${fieldName}.disable_existing`} component={ToggleField} />
            </Col>
          </Fragment>
        )}
      </FormGroup>
    </Fragment>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    address_book_companies: state.address_book_companies,
  };
};

export let CompanyFieldForm = (props) => {
  const { label, placeholder, required: isRequired, preview, name, prefixName, disabled, address_book_companies, add_new, disable_existing } = props;

  const form = useForm();

  useEffect(() => {
    props.getAddressBookCompanies();
  }, []);

  return (
    <Fragment>
      <FormGroup row>
        <Label md={2}>
          {label}
          {isRequired && "*"}
          {add_new && (
            <AddressBookCompanyAddButton
              onSuccess={(id) => {
                if (id) {
                  form.change(`${prefixName}.${name}`, id);
                }
              }}
            />
          )}
        </Label>
        <Col md={10}>
          <Field
            name={`${prefixName}.${name}`}
            disabled={preview || disabled}
            component={ReactSelect}
            options={_.map(address_book_companies, (p) => {
              return { value: p.id, label: p.name, isDisabled: disable_existing && !p.new_record };
            })}
            placeholder={placeholder || "Select Company"}
            validate={isRequired && !preview ? required : null}
          />
        </Col>
      </FormGroup>
    </Fragment>
  );
};
CompanyFieldForm.defaultProps = {
  prefixName: "data",
};

CompanyFieldForm = connect(mapStateToProps, { getAddressBookCompanies })(CompanyFieldForm);

const mapStateToPropsFormMobile = (state, ownProps) => {
  return {
    address_book_companies: state.address_book_companies,
  };
};

export let MobileCompanyFieldForm = (props) => {
  const { label, placeholder, required: isRequired, preview, name, prefixName, disabled, disable_existing, address_book_companies } = props;

  useEffect(() => {
    props.getAddressBookCompanies();
  }, []);

  const sorted_companies = _.sortBy(address_book_companies, (c) => c.name);
  return (
    <Field
      name={`${prefixName}.${name}`}
      label={label}
      disabled={preview || disabled}
      component={SmartSelect}
      options={_.map(sorted_companies, (sp) => {
        return { value: sp.id, label: sp.name, isDisabled: disable_existing && !sp.new_record };
      })}
      placeholder={placeholder}
      validate={isRequired && !preview ? required : null}
      valueName="value"
      labelName="label"
    />
  );
};

MobileCompanyFieldForm = connect(mapStateToPropsFormMobile, { getAddressBookCompanies })(MobileCompanyFieldForm);

MobileCompanyFieldForm.defaultProps = {
  prefixName: "data",
};
